import axios from 'axios';
import { getAuthToken } from '../../../tools/session/clientSession';
import { emitLoadingEnd, emitLoadingProgress, emitLoadingStart } from '../../../common/loading/loadingEvents';

export const API_BASE_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL + '/api'
  : '/api';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    let endpointName = 'API';
    if (config.url) {
      endpointName = config.url.split('/').pop().split('?')[0];
    }
    emitLoadingStart(endpointName);

    config.onDownloadProgress = (progressEvent) => {
      if (progressEvent.total) {
        const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        emitLoadingProgress(endpointName, percentage);
      }
    };

    return config;
  },
  (error) => {
    const endpointName = error?.config?.url?.split('/').pop().split('?')[0] || 'API';
    emitLoadingEnd(endpointName);
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    const endpointName = response.config?.url?.split('/').pop().split('?')[0] || 'API';
    emitLoadingEnd(endpointName);
    return response;
  },
  (error) => {
    const endpointName = error?.config?.url?.split('/').pop().split('?')[0] || 'API';
    console.error('API Error:', error);
    emitLoadingEnd(endpointName);
    return Promise.reject(error);
  }
);

export const getAuthHeaders = (contentType = 'application/json') => {
  const token = getAuthToken();
  return {
    Authorization: token ? `Bearer ${token}` : undefined,
    'Content-Type': contentType,
  };
};
